// extracted by mini-css-extract-plugin
export default {"root":"Header_root__Cg+dm","logout":"Header_logout__wz5LM","info":"Header_info__25aOS"};